import _ from 'lodash'

const getLeafNodes = data => {

  const paths = getPaths(data)

  const leafNodes = paths.filter(path => {
    let node = _.get(data, path)
    let hasChildren = typeof node === "object"

    return !hasChildren || node === null
  })

  return leafNodes
}

export default getLeafNodes

const getPaths = (obj, currentPath = '', paths = []) => {
  if (typeof obj !== 'object' || obj === null) {
    return paths
  }

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      const newPath = currentPath === '' ? property : `${currentPath}.${property}`

      if (Array.isArray(obj[property])) {
        obj[property].forEach((item, index) => {
          getPaths(item, `${newPath}[${index}]`, paths)
        })
      } else {
        getPaths(obj[property], newPath, paths)
      }

      paths.push(newPath.replace("[", ".").replace("]", ""))
    }
  }

  return paths
}